export const painPoints: string[] = [
  'You scan the room before class, quietly praying nobody mentions an injury',
  'A client says "sciatica" and you nod confidently while panicking inside',
  'You\'ve googled "is Pilates safe for a herniated disc" at 8:58 with a client waiting',
  'You water the whole class down "just in case" — and your strong regulars notice',
  'You lie awake replaying a modification, wondering if you made something worse',
  '"Who do you think you are?" runs on a loop in your head before you teach',
  "You're terrified of the day someone gets hurt — and of what comes after",
  'Your certification cost thousands — and it never covered this exact moment',
];
